import './App.css';
import HomePage from './pages/HomePage';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';

import ScrollToTop from './pages/ScrollToTop'; // make sure this path is correct
import LockerSizes from './pages/LockerSizes';

function App() {
  return (
    <Router>
      <ScrollToTop /> {/* ← this is the key line */}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/privacypage" element={<PrivacyPage />} />
        <Route path="/termspage" element={<TermsPage />} />
        <Route path ='/locker-sizes' element={<LockerSizes />} />
      </Routes>
    </Router>
  );
}

export default App;
